<template>
  <td :colspan="headers.length" class="content pl-13 pb-10">
    <v-card class="rounded-b-lg" outlined>
      <p class="pa-5 mb-0 font-weight-bold">{{ $t('hausefulInvoices.paymentList') }}</p>
      <v-data-table :headers="pendingInvoicesPaymentsHeaders" :items="payments" item-key="code" hide-default-footer
        disable-sort>
        <template v-slot:item.appointment_code="{ item }">
          <a :href="`/admin-appointment/${item.appointment_id}`" target="_blank">
            {{ item.appointment_code }}
          </a>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
        <template v-slot:item.description="{ item }">
          {{ description(item.description) }}
        </template>
        <template v-slot:item.payment_type="{ item }">
          {{ paymentType(item) }}
        </template>
        <template v-slot:item.hauseful_value="{ item }">
          <span :class="moneyColor(item.hauseful_value)">
            {{ formatMoney(item.hauseful_value) }}
          </span>
        </template>
        <template v-slot:item.host_value="{ item }">
          <span :class="moneyColor(item.host_value)">
            {{ formatMoney(item.host_value) }}
          </span>
        </template>
        <template v-slot:item.movement_value="{ item }">
          <span :class="moneyColor(item.movement_value)">
            {{ formatMoney(item.movement_value) }}
          </span>
        </template>
      </v-data-table>
    </v-card>
  </td>
</template>

<script>
import { pendingInvoicesPaymentsHeaders } from '../../adminInvoiceHeaders'
import { catalogDate, catalogMonetary } from '@/util/catalog'

export default {
  name: 'PaymentListPending',

  props: {
    headers: {
      type: Array,
      required: true,
    },

    payments: {
      type: Array,
      required: false,
    },
  },

  methods: {
    formatDate(date) {
      return catalogDate(date)
    },

    formatMoney(value) {
      return catalogMonetary(value)
    },

    description(description) {
      return description ?? '---'
    },

    paymentType(item) {
      return item.payment_type ? this.$t(`transfer.transferStatus.${item.payment_type}`) : '---'
    },

    moneyColor(value) {
      return value < 0 ? 'red--text text--lighten-1' : 'green--text text--lighten-1'
    },
  },

  data() {
    return {
      pendingInvoicesPaymentsHeaders,
    }
  },
}
</script>
